import * as React from "react";
import { get, size } from "lodash";
import { Locale } from "@linkfluence/models/locale";
import FiltersRecap from "@radarly/components/filters-recap";
import Modal from "@radarly/components/modals/queries-infos";
// import useTranslations from "@radarly/core/facets/translate";
import { useQueryDetails } from "@radarly/core/queries/use-cases";
import { tr } from "@radarly/i18n";
import { getQueryFromClause } from "@radarly/models/clause/getter";
import { Project } from "@radarly/models/project";

function getParents(details, entry) {
  const parents = get(details, "parentsDetails", {});
  return parents[entry] || [];
}

interface IProps {
  project: Project;
  locale: Locale;
  focus: number;
  close: () => void;
}

const RadarlyModalQueriesInfos = ({
  project,
  locale,
  focus,
  close,
}: IProps) => {
  const { details, loading } = useQueryDetails(project.id, focus);

  //TODO: check this, ça tourne en boucle ici
  const labels = []; //useTranslations(filters);
  return (
    <Modal
      onCancel={() => close()}
      locale={locale}
      loading={loading || details === null}
      query={details}
      search={getQueryFromClause(details?.filter?.clause) || ""}
      project={project}
      includes={loading ? [] : getParents(details, "include")}
      excludes={loading ? [] : getParents(details, "exclude")}
      filters={
        size(labels) ? (
          <FiltersRecap
            tooltiped
            labelizedFilters={labels}
            withFacetIcon
            facetsValuesGlue={" " + tr(locale, "FILTER_PANEL.OR") + " "}
          />
        ) : null
      }
    />
  );
};

export default RadarlyModalQueriesInfos;
